var _rect, _path, _path2, _path3, _path4, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExodus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 4,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3547_9470)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.8922 16.3195L27.6282 5V11.3288L38.7033 18.5255L37.4003 22.6484H27.6282V27.8922H37.4003L38.7033 32.015L27.6282 39.2118V45.5405L44.8922 34.2572L42.0693 25.2884L44.8922 16.3195Z",
    fill: "url(#paint0_linear_3547_9470)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6082 27.8922H22.3441V22.6484H12.572L11.3053 18.5255L22.3441 11.3288V5L5.08008 16.3195L7.90313 25.2884L5.08008 34.2572L22.3803 45.5405V39.2118L11.3053 32.015L12.6082 27.8922Z",
    fill: "url(#paint1_linear_3547_9470)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3547_9470",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 40,
    height: 41
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8925 16.3195L27.6284 5V11.3288L38.7034 18.5255L37.4004 22.6484H27.6284V27.8922H37.4004L38.7034 32.015L27.6284 39.2118V45.5405L44.8925 34.2572L42.0694 25.2884L44.8925 16.3195Z",
    fill: "url(#paint2_linear_3547_9470)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6082 27.8922H22.3442V22.6484H12.572L11.3053 18.5255L22.3442 11.3288V5L5.08008 16.3195L7.90314 25.2884L5.08008 34.2572L22.3804 45.5405V39.2118L11.3053 32.015L12.6082 27.8922Z",
    fill: "url(#paint3_linear_3547_9470)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3547_9470)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.6283 5H5.10132V45.5405H44.6283V5Z",
    fill: "url(#paint4_linear_3547_9470)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3547_9470",
    x1: 39.3074,
    y1: 48.3277,
    x2: 27.7432,
    y2: 0.547851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B46F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBFBE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3547_9470",
    x1: 39.3074,
    y1: 48.3277,
    x2: 27.7432,
    y2: 0.54785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B46F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBFBE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3547_9470",
    x1: 39.3075,
    y1: 48.3277,
    x2: 27.7433,
    y2: 0.54785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B46F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBFBE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3547_9470",
    x1: 39.3074,
    y1: 48.3277,
    x2: 27.7432,
    y2: 0.547852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B46F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBFBE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3547_9470",
    x1: 7.6351,
    y1: 14.1216,
    x2: 27.652,
    y2: 29.0709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.119792,
    stopColor: "#8952FF",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DABDFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3547_9470"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40.5405,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExodus);
export default __webpack_public_path__ + "static/media/Exodus.77ffe487361d4b65d609432574fdfd96.svg";
export { ForwardRef as ReactComponent };